import { render, staticRenderFns } from "./BankNameTaiko.vue?vue&type=template&id=3a53759a&scoped=true&"
import script from "./BankNameTaiko.vue?vue&type=script&lang=ts&"
export * from "./BankNameTaiko.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53759a",
  null
  
)

export default component.exports